import { queryList, initUserType, updateObject} from './../api';
const userType = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    updateData: null,
    initUserTypeData: null,
    total: null,
  },
  mutations: {
    QUERYLIST(state, resp) {
      state.total = resp.total
      state.resp = resp.obj
    },
    UP_DATE_OBJECT(state, resp) {
      state.updateData = resp
    },
    INIT_USER_TYPE(state, resp) {
      state.initUserTypeData = resp
    },
  },
  actions: {
    async setData({ commit }, data) {
      commit('setData', data);
    },
    async queryList({ commit }, obj) {
      let resp = await queryList(obj);
      commit('QUERYLIST', resp);
    },
    async initUserType({ commit }, obj) {
      let resp = await initUserType(obj);
      commit('INIT_USER_TYPE', resp);
    },
    async updateObject({ commit }, obj) {
      let resp = await updateObject(obj);
      commit('UP_DATE_OBJECT', resp);
    },
  }
}

export default userType



// WEBPACK FOOTER //
// ./src/page/auth/userType/store/userType.store.js